import moment from "moment";

/** Parse a weight-table row date (ISO diaryDate, or legacy DD/MM label). */
export function parseDiaryDate(item) {
	if (item && item.diaryDate) {
		const iso = moment(item.diaryDate, "YYYY-MM-DD");
		if (iso.isValid()) {
			return iso.toDate();
		}
	}
	if (item && item.diaryDateFormated) {
		const dmy = moment(item.diaryDateFormated, "DD/MM");
		if (dmy.isValid()) {
			return dmy.toDate();
		}
	}
	return new Date();
}

export function findTableRowForDate(rows, calendarDate) {
	if (!Array.isArray(rows) || !calendarDate) {
		return undefined;
	}
	const iso = moment(calendarDate).format("YYYY-MM-DD");
	const dmy = moment(calendarDate).format("DD/MM");
	return rows.find(
		(row) =>
			row.diaryDate === iso ||
			row.diaryDateFormated === dmy ||
			row.diaryDateFormated === iso
	);
}

export function weightDiaryDisplayDate(item) {
	if (!item) {
		return "";
	}
	return item.diaryDateLabel || item.diaryDateFormated || "";
}
